// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8e872fc4","667":"a916fa8b","977":"a7d87274"}[chunkId] + ".chunk.js";
};